import { Tooltip } from '@material-ui/core';
import React from 'react';
import AccessTime from '@material-ui/icons/AccessTime';
import Send from '@material-ui/icons/Send';
import Error from '@material-ui/icons/Error';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Lock from '@material-ui/icons/Lock';
import Cancel from '@material-ui/icons/Cancel';
import { IconContainer } from './styles';

const STATUS_CONFIG = {
  'Pendente': {
    color: '#FFC107',
    label: 'Pendente',
    Icon: AccessTime
  },
  'Enviado': {
    color: '#2196F3',
    label: 'Enviado',
    Icon: Send
  },
  'Rejeitado': {
    color: '#F44336',
    label: 'Rejeitado',
    Icon: Error
  },
  'Autorizado': {
    color: '#4CAF50',
    label: 'Autorizado',
    Icon: CheckCircle
  },
  'Encerrado': {
    color: '#607D8B',
    label: 'Encerrado',
    Icon: Lock
  },
  'Cancelado': {
    color: '#D32F2F',
    label: 'Cancelado',
    Icon: Cancel
  }
};

export default function BadgeStatusDocumento({ status }) {
  // Se não houver status, não exibir badge
  if (!status) {
    return null;
  }

  // Normalizar o status para o formato esperado (primeira letra maiúscula, resto minúscula)
  const normalizedStatus = String(status).charAt(0).toUpperCase() + String(status).slice(1).toLowerCase();
  
  // Se status desconhecido, não exibir badge
  if (!STATUS_CONFIG[normalizedStatus]) {
    console.warn(`Status de documento desconhecido: ${status}`);
    return null;
  }

  const config = STATUS_CONFIG[normalizedStatus];
  const IconComponent = config.Icon;

  return (
    <Tooltip title={`Status do Documento: ${config.label}`} arrow>
      <IconContainer color={config.color}>
        <IconComponent />
      </IconContainer>
    </Tooltip>
  );
}

